import mapFunction from './mapResources';

export default mapFunction('building_last_performances', {
    isFetching: false,
    items: []
});